import { createWelcomeStep, createMiddleStep, createFinalStep } from '../config/stepTemplates';
import { waitForElement } from '../utils/tourUtils';

const TOTAL = 4;

export function getSettingsTourSteps(t) {
  return [
    {
      ...createWelcomeStep({
        id: 'settings-sidebar',
        title: t('onboarding_tour.settings.step1.title', 'Settings'),
        text: t('onboarding_tour.settings.step1.text', 'Account, team, billing, and AI customization.'),
        attachTo: { element: '[data-tour="settings-sidebar"]', on: 'right' },
        t,
        totalSteps: TOTAL,
      }),
      beforeShowPromise() {
        return waitForElement('[data-tour="settings-sidebar"]', 5000).catch(() => {});
      },
    },
    {
      ...createMiddleStep({
        id: 'settings-prompts-tab',
        title: t('onboarding_tour.settings.step2.title', 'AI Prompt Customization'),
        text: t('onboarding_tour.settings.step2.text', 'Tailor how the AI responds for your organization.'),
        attachTo: { element: '[data-tour="settings-prompts-tab"]', on: 'right' },
        t,
        stepIndex: 2,
        totalSteps: TOTAL,
      }),
      when: {
        show() {
          // Click the prompts tab to navigate to it
          const tab = document.querySelector('[data-tour="settings-prompts-tab"]');
          if (tab) tab.click();
        },
      },
    },
    {
      ...createMiddleStep({
        id: 'settings-prompt-field',
        title: t('onboarding_tour.settings.step3.title', 'Write Your Prompt'),
        text: t('onboarding_tour.settings.step3.text', 'Describe your expertise, preferred style, and specific instructions. Applies to all team members.'),
        attachTo: { element: '[data-tour="prompt-text-field"]', on: 'top' },
        t,
        stepIndex: 3,
        totalSteps: TOTAL,
      }),
      beforeShowPromise() {
        return waitForElement('[data-tour="prompt-text-field"]', 3000).catch(() => {});
      },
    },
    createFinalStep({
      id: 'settings-personalized',
      title: t('onboarding_tour.settings.step4.title', 'Personalized AI'),
      text: t('onboarding_tour.settings.step4.text', 'Your prompt shapes every AI interaction across search, chat, and contracts.'),
      t,
      totalSteps: TOTAL,
    }),
  ];
}
